module.exports = "/_next/static/resources/photo-1-5949cf68fbb6d5d7ca0a6e3bd50b9c64.jpg";